export const GoogleExtensionIcon = () => {
  return <img className="flex size-16" src="/chrome-store.svg" alt="" />;
};
